define('components/course/models/slide-type/click-and-reveal',[
    'components/course/models/slide-type/zeus-base',
    'components/course/models/click-and-reveal-component'
], function(BaseModel, ComponentClickAndRevealModel) {
    "use strict";

    return BaseModel.extend({
        "clickAndRevealComponentModel": null,
        "defaults": function() {
            var baseDefaults = BaseModel.prototype.defaults.apply(this, arguments),
                clickAndRevealDefaults = {

                    "type": "click-and-reveal",
                    "data": {
                        /* This property holds model for click and reveal component model
                         *
                         * @property clickAndRevealComponentModel
                         * @type {Backbone.Model}
                         * @default null
                         */
                        "clickAndRevealComponentModel": {},
                        "authorValidationTextArray": [],
                        "isDECall": true,
                        "saveState": {
                            "hotspots_state": []
                        }
                    }
                };

            return _.extend(baseDefaults, clickAndRevealDefaults);
        },

        "initialize": function() {
            this._populateData();
            this._createComponentModel();
        },

        "authoringJSONKey": function() {
            return _.extend(BaseModel.prototype.authoringJSONKey.call(this), {
                "data": {
                    "clickAndRevealComponentModel": null,
                    "authorValidationTextArray": null,
                    "isValidate": null,
                    "isDECall": null,
                    "globalComponentData": null
                }
            });
        },

        "_populateData": function() {
            var newData,
                data = this.get('data');

            if (!data) {
                newData = {
                    "clickAndRevealComponentModel": {},
                    "authorValidationTextArray": [],
                    "isValidate": true,
                    "isDECall": true,
                    "saveState": {
                        "hotspots_state": []
                    }
                };
                this.set('data', newData);
            }

            if (data && !data.saveState) {
                this.set('data', _.extend(data, {
                    "saveState": {
                        "hotspots_state": []
                    }
                }));
            }
        },

        /**
         * This method create click and reveal component model and stores it into the model attributes
         *
         * @method _destroyPreviousTooltips
         * @param {Backbone.Model} hotspotMode active hotspot model
         * @param {Number} index, index of active hotspot in collection
         * @return {Backbone.View} reference to current model
         */
        "_createComponentModel": function() {

            var data = this.get('data'),
                options = data.clickAndRevealComponentModel || {};
            options.isDECall = data.isDECall;
            this.clickAndRevealComponentModel = new ComponentClickAndRevealModel(options);
            return this;
        },

        /**
         * This method remove attributes filter json attributes and remove those which are not of any use.
         *
         * @method filterJsonAttributes
         * @param {String} json property in string format
         * @param {value} value for the json property
         * @return base on condition value to assign to property
         */
        "filterJsonAttributes": function(key, value) {
            var returnValue = value;

            switch (key) {
                case 'radioChannel':
                case 'visitedHotspots':
                case 'totalNumberOfHotspots':
                case 'hotspotCollection':
                case 'tooltipModelArray':
                case 'templateText':
                case 'defaultEditorSize':
                case 'wordControlModel':
                case 'validateStateType':
                case 'validatationTextArray':
                case 'paragraphModelArray':
                case 'authorValidationTextArray':
                case 'data':
                case 'cachedBounds':
                    returnValue = void 0;
                    break;
            }
            return returnValue;
        }
    });
});

